import { css } from '@emotion/react';

export const rootStyles = css`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
  padding: var(--spacing-6);
  background: var(--surface-page);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  color: var(--text-primary);
`;

export const headingStyles = css`
  && {
    display: flex;
    align-items: center;
    gap: var(--spacing-3);
    margin: 0 0 var(--spacing-4);
  }
`;

export const markerStyles = css`
  display: grid;
  flex-shrink: 0;
  place-items: center;
  width: var(--spacing-6);
  height: var(--spacing-6);
  border-radius: var(--radius-round);
  background: var(--color-primary-800);
`;
